export default {
    CLOCK: 1,
    MEMBER: 2,
    NON_MEMBER: 3,
    1: 'Clock',
    2: 'Member',
    3: 'NonMember'
}